import React from "react";

import EmptyData from "@onair/ui/empty-data";

interface Props {}

export const NotificationEmpty = (props: Props) => {
	return (
		<EmptyData
			title="Không có thông báo mới"
			description="Rất tiếc, thông báo của bạn đang trống!"
		/>
	);
};
